import React, { useState, useEffect } from 'react';
import { useAuth } from '../App';
import Layout from '../components/Layout';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { Input } from '../components/ui/input';
import { PlusCircle, FileText, Upload, Eye } from 'lucide-react';
import { toast } from 'sonner';
import AccessRequestsAdmin from "../pages/AccessRequestsAdmin";
import { useNavigate } from "react-router-dom";

export default function Soins() {
  const { axiosInstance, user } = useAuth();
  const navigate = useNavigate();

  const [patients, setPatients] = useState([]);
  const [editingPatient, setEditingPatient] = useState(null);
  const [users, setUsers] = useState([]);

  const [creatingPatient, setCreatingPatient] = useState(false);
  const [accessCode, setAccessCode] = useState('');
  const [showTrash, setShowTrash] = useState(false);
  const [trashPatients, setTrashPatients] = useState([]);
  const [openedPatient, setOpenedPatient] = useState(null);
  const [searchPatient,setSearchPatient]=useState("");
  const [prestations, setPrestations] = useState([]);
  const [editingPrestation, setEditingPrestation] = useState(null);
  const [creatingPrestation, setCreatingPrestation] = useState(false);
  const [loadingPatients, setLoadingPatients] =
  useState(true);
  const currentDate = new Date();
  const [selectedMonth, setSelectedMonth] = useState(
    String(currentDate.getMonth() + 1).padStart(2, "0")
  );
  const [selectedYear, setSelectedYear] = useState(
    String(currentDate.getFullYear())
  );
  const [selectedCaregiver, setSelectedCaregiver] = useState("");
  const [monthlyTotals, setMonthlyTotals] = useState({});
  const [loadingMonthlyAmount, setLoadingMonthlyAmount] =
  useState(false);
  const [savingMonthlyAmount, setSavingMonthlyAmount] =
  useState(false);
  // const [otherPatients, setOtherPatients] = useState([]);
  const [externalCaregivers, setExternalCaregivers] = useState([]);
  const [externalCaregiversCode, setExternalCaregiversCode] = useState("");
  const [externalCaregiversUnlocked, setExternalCaregiversUnlocked] =
  useState(false);
  const [checkingExternalCode, setCheckingExternalCode] =
  useState(false);
  const [accessStatus, setAccessStatus] = useState("loading");

  const getEmptyPrestation = () => ({
    date: new Date().toISOString().split("T")[0],
    caregiver_type: "registered",
    soignant_id: "",
    soignant_externe_id: "",
    patient_id: "",
    patients: [],
    notes: ""
  });

  const [newPrestation, setNewPrestation] = useState(
    getEmptyPrestation()
  );

  // Planning mensuel : plusieurs dates, avec patients et créneaux propres à chaque jour.
  const [planningMonth, setPlanningMonth] = useState(
    `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}`
  );
  const [planningDays, setPlanningDays] = useState({});

// const [newPrestation, setNewPrestation] = useState(emptyPrestation);

 

  const [patientDocs, setPatientDocs] = useState({
    identity_card: null,
    identity_card_back: null,
    vignette: null,
    prescription_medicale: null,
    echelle_katz: null,
    fiche_patient: null,

  });

  const [newPatient, setNewPatient] = useState({
    nom: '',
    prenom: '',
    adresse: '',
    telephone: '',
    email: '',
    numero_national: '',
    date_naissance: '',
    date_debut: '',
    date_fin: '',
    assurabilite: 'mutuelle',
    documents: {
      identity_card: null,
      identity_card_back: null,
      vignette: null,
      prescription_medicale: null,
      echelle_katz: null,
      fiche_patient: null,
    },
    description_documents: '',
  });


  const [userNotes, setUserNotes] = useState({});
  const isAdminOrCoordinator =
    user?.role === "admin" ||
    user?.care_role === "coordinateur";

  const currentUserId = String(
    user?.id ||
    user?._id ||
    user?.user_id ||
    ""
  ).trim();

  const canManagePatients = isAdminOrCoordinator;
  const canManagePrestations = isAdminOrCoordinator;
  const canManageCaregivers = isAdminOrCoordinator;
  const canAccessTrash = isAdminOrCoordinator;
  const canEditDocuments = isAdminOrCoordinator;

  /*
  * Un soignant peut accéder à la page uniquement si
  * le backend lui retourne au moins un patient assigné.
  */
  const hasActiveAccess =
    isAdminOrCoordinator ||
    accessStatus === "active";

  const hasAssignedPatients =
    hasActiveAccess &&
    patients.length > 0;

  const canViewCarePage =
    isAdminOrCoordinator ||
    (
      accessStatus === "active" &&
      hasAssignedPatients
    );
    
  const displayPatients = showTrash ? trashPatients : patients;
  const patientStats = {
    total: patients.length + trashPatients.length,
    actifs: patients.length,
    archives: trashPatients.length,
    mutuelle: patients.filter(p => p.assurabilite === "mutuelle").length,
    sansMutuelle: patients.filter(p => p.assurabilite === "sans_mutuelle").length,
    avecTelephone: patients.filter(p => p.telephone).length,
    avecEmail: patients.filter(p => p.email).length,
  };

   const filteredPatients = displayPatients.filter(p=>{

    const search = searchPatient.toLowerCase();

      return (
      p.nom?.toLowerCase().includes(search) ||
      p.prenom?.toLowerCase().includes(search) ||
      p.telephone?.includes(search) ||
      p.email?.toLowerCase().includes(search)
      );

      });
    

  const isCareUser = [
  "caregiver",
  "nurse",
  "aide_soignant",
  "stagiaire"
].includes(user.role) || user.care_role === "soignant";

const fetchAccessStatus = async () => {
  if (isAdminOrCoordinator) {
    setAccessStatus("active");
    return "active";
  }

  try {
    const response = await axiosInstance.get(
      "/access-request/status"
    );

    const backendStatus = response.data?.status;
    const isActive = response.data?.active === true;

    const status = isActive
      ? "active"
      : backendStatus === "pending"
        ? "pending"
        : "none";

    setAccessStatus(status);

    return status;
  } catch (err) {
    console.error(
      "Erreur vérification accès :",
      err.response?.data || err
    );

    // Ne pas supprimer l'accès local sur une simple erreur réseau.
    setAccessStatus("none");
    return "none";
  }
};
 
  
const fetchAssignedCareData = async () => {
  try {
    const prestationResponse = await axiosInstance.get(
      "/prestations-domicile"
    );

    const prestationList = Array.isArray(
      prestationResponse.data
    )
      ? prestationResponse.data
      : prestationResponse.data?.prestations || [];

    console.log(
      "Prestations attribuées au soignant :",
      prestationList
    );

    setPrestations(prestationList);

    /*
     * On récupère les patients directement depuis
     * les prestations attribuées au soignant.
     */
    const assignedPatientsMap = new Map();

    prestationList.forEach((prestation) => {
      const patient = prestation.patient;

      if (!patient) {
        console.warn(
          "Patient absent dans la prestation :",
          prestation
        );
        return;
      }

      const patientId = String(
        patient._id ||
        prestation.patient_id ||
        ""
      ).trim();

      if (!patientId) return;

      assignedPatientsMap.set(patientId, {
        ...patient,

        // Adaptation avec les noms utilisés dans ton frontend
        _id: patientId,

        prenom:
          patient.prenom ||
          patient.first_name ||
          "",

        nom:
          patient.nom ||
          patient.last_name ||
          "",

        adresse:
          patient.adresse ||
          patient.address ||
          "",

        telephone:
          patient.telephone ||
          patient.phone ||
          ""
      });
    });

    const assignedPatients = Array.from(
      assignedPatientsMap.values()
    );

    console.log(
      "Patients déduits des prestations :",
      assignedPatients
    );

    setPatients(assignedPatients);

    return assignedPatients;
  } catch (err) {
    console.error(
      "Erreur chargement des prestations attribuées :",
      err.response?.data || err
    );

    setPrestations([]);
    setPatients([]);

    toast.error(
      err.response?.data?.detail ||
      "Erreur lors du chargement des patients attribués"
    );

    return [];
  }
};

useEffect(() => {
  if (!user) return;

  const initializeCarePage = async () => {
    setLoadingPatients(true);

    try {
      if (isAdminOrCoordinator) {
        setAccessStatus("active");

        await Promise.all([
          fetchPatients(),
          fetchPrestations(),
          fetchUsers(),
          fetchTrash()
        ]);

        return;
      }

      const status = await fetchAccessStatus();

      if (status === "active") {
        // Important : récupérer les prestations attribuées
        // avant de décider que le soignant n'a aucun patient.
        await fetchAssignedCareData();
      } else {
        setPatients([]);
        setPrestations([]);
      }

      setUsers([]);
      setTrashPatients([]);
    } finally {
      setLoadingPatients(false);
    }
  };

  initializeCarePage();
}, [
  user?.id,
  user?._id,
  user?.role,
  user?.care_role
]);







  const fetchPatients = async () => {
    setLoadingPatients(true);

    try {
      const res = await axiosInstance.get("/patients");

      const patientList = Array.isArray(res.data)
        ? res.data
        : res.data?.patients || [];

      const activePatients = patientList.filter(
        (patient) =>
          patient.archived !== true &&
          patient.status !== "deleted"
      );

      setPatients(activePatients);

      console.log(
        "Patients accessibles à cet utilisateur :",
        activePatients
      );
    } catch (err) {
      console.error(
        "Erreur chargement patients :",
        err.response?.data || err
      );

      setPatients([]);

      toast.error(
        err.response?.data?.detail ||
        "Erreur chargement patients"
      );
    } finally {
      setLoadingPatients(false);
    }
  };

  const handleDeletePatient = async (id) => {
    if (!window.confirm("Supprimer ce patient(corbeille) ?")) return;
    try {
      await axiosInstance.delete(`/patients/${id}`);
      toast.success("Patient supprimé");
      fetchPatients();
    } catch {
      toast.error("Erreur suppression patient");
    }
  };

  const handleArchivePatient = async (patientId) => {
    try {
      await axiosInstance.put(`/patients/${patientId}/archive`);

      toast.success("Patient archivé");

      fetchPatients();
      fetchTrash();
    } catch (err) {
      console.error(err);
      toast.error("Erreur lors de l'archivage");
    }
  };

  const startEditPatient = (p) => {
    setEditingPatient(p._id);

    const dateNaissance = p.date_naissance ? p.date_naissance.split('T')[0] : '';
    const dateDebut = p.date_debut ? p.date_debut.split('T')[0] : '';
    const dateFin = p.date_fin ? p.date_fin.split('T')[0] : '';

    setNewPatient({
      nom: p.nom || '',
      prenom: p.prenom || '',
      adresse: p.adresse || '',
      telephone: p.telephone || '',
      email: p.email || '',
      numero_national: p.numero_national || '',
      date_naissance: dateNaissance,
      date_debut: dateDebut,
      date_fin: dateFin,
      assurabilite: p.assurabilite || 'mutuelle',
      documents: p.documents || {
        identity_card: null,
        vignette: null,
        prescription_medicale: null,
      },
      description_documents: p.description_documents || '',
    });
  };

  const getUserFirstName = (person) =>
    person?.first_name ||
    person?.prenom ||
    "";

  const getUserLastName = (person) =>
    person?.last_name ||
    person?.nom ||
    "";

  const getFullName = (person) => {
    if (!person) return "";

    return `${getUserFirstName(person)} ${getUserLastName(
      person
    )}`.trim();
  };


  const handleRestorePatient = async (id) => {
  try {
    await axiosInstance.put(`/patients/${id}/restore`);
    toast.success("✅ Patient restauré !");
    
    // 🚀 RECHARGEMENT SYNCHRONE
    setTimeout(async () => {
      await Promise.all([
        fetchPatients(),  // Liste active ✅
        fetchTrash()      // Corbeille ✅
      ]);
      setShowTrash(false);  // Auto retour liste principale
    }, 500);
    
  } catch (err) {
    toast.error("❌ Erreur restauration");
  }
};

  const handleUpdatePatient = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.put(`/patients/${editingPatient}`, newPatient);
      toast.success("Patient mis à jour");
      setEditingPatient(null);
      setNewPatient({
        nom: '',
        prenom: '',
        adresse: '',
        telephone: '',
        email: '',
        numero_national: '',
        date_naissance: '',
        date_debut: '',
        date_fin: '',
        assurabilite: 'mutuelle',
        documents: {
          identity_card: null,
          vignette: null,
          prescription_medicale: null,
        },
        description_documents: '',
      });
      fetchPatients();
    } catch {
      toast.error("Erreur mise à jour patient");
    }
  };

    const monthlyCaregiverSummary = prestations
      .filter((prestation) => {
        if (!prestation.date) return false;

        const prestationDate = new Date(prestation.date);

        return (
          prestationDate.getMonth() + 1 === Number(selectedMonth) &&
          prestationDate.getFullYear() === Number(selectedYear)
        );
      })
      .reduce((summary, prestation) => {
        const caregiver =
          prestation.soignant ||
          prestation.soignant_id ||
          prestation.soignant_externe ||
          prestation.soignant_externe_id;

        const caregiverId = String(
          caregiver?.id ||
          caregiver?._id ||
          caregiver?.user_id ||
          prestation.soignant_id ||
          prestation.soignant_externe_id ||
          "inconnu"
        );

        const caregiverName =
          getFullName(caregiver) ||
          prestation.soignant_nom ||
          prestation.soignant_externe_nom ||
          "Soignant inconnu";

        if (!summary[caregiverId]) {
          summary[caregiverId] = {
            caregiverId,
            caregiverName,
            prestationsCount: 0,
            passagesCount: 0
          };
        }

        summary[caregiverId].prestationsCount += 1;

        summary[caregiverId].passagesCount += Array.isArray(
          prestation.passages
        )
          ? prestation.passages.length
          : 0;

        return summary;
      }, {});

    const monthlyCaregivers = Object.values(
      monthlyCaregiverSummary
    );
 
const normalizeId = (value) => {
  if (!value) return "";

  if (typeof value === "string") {
    return value.trim();
  }

  return String(
    value._id ||
    value.id ||
    value.user_id ||
    ""
  ).trim();
};

const selectedCaregiverPrestations = prestations
  .filter((prestation) => {
    if (!prestation.date || !selectedCaregiver) {
      return false;
    }

    const prestationDate = new Date(prestation.date);

    const sameMonth =
      prestationDate.getMonth() + 1 === Number(selectedMonth);

    const sameYear =
      prestationDate.getFullYear() === Number(selectedYear);

    const prestationSoignantId =
      normalizeId(prestation.soignant_id) ||
      normalizeId(prestation.soignant);

    return (
      sameMonth &&
      sameYear &&
      prestationSoignantId === normalizeId(selectedCaregiver)
    );
  })
  .sort(
    (a, b) =>
      new Date(a.date) - new Date(b.date)
  );

      // ============================================================
    // MONTANT MENSUEL DU SOIGNANT
    // ============================================================

    const monthlyTotalKey =
      `${selectedYear}-${selectedMonth}-${normalizeId(selectedCaregiver)}`;

    const selectedMonthlyAmount =
      monthlyTotals[monthlyTotalKey] ?? "";


    // ------------------------------------------------------------
    // MODIFIER LE MONTANT DANS LE CHAMP
    // ------------------------------------------------------------

    const handleMonthlyAmountChange = (value) => {
      setMonthlyTotals((prev) => ({
        ...prev,
        [monthlyTotalKey]: value
      }));
    };


    // ------------------------------------------------------------
    // CHARGER LE MONTANT DEPUIS LA BASE DE DONNÉES
    // ------------------------------------------------------------

    const fetchMonthlyAmount = async () => {
      if (!selectedCaregiver) {
        return;
      }

      setLoadingMonthlyAmount(true);

      try {
        const response = await axiosInstance.get(
          "/montants-mensuels-soignants",
          {
            params: {
              soignant_id: normalizeId(selectedCaregiver),
              mois: Number(selectedMonth),
              annee: Number(selectedYear)
            }
          }
        );

        const montant =
          response.data?.montant ?? "";

        setMonthlyTotals((prev) => ({
          ...prev,
          [monthlyTotalKey]: montant
        }));

      } catch (err) {
        console.error(
          "Erreur chargement montant mensuel :",
          err.response?.data || err
        );

        setMonthlyTotals((prev) => ({
          ...prev,
          [monthlyTotalKey]: ""
        }));

        toast.error(
          err.response?.data?.detail ||
          "Impossible de charger le montant mensuel."
        );

      } finally {
        setLoadingMonthlyAmount(false);
      }
    };


    // ------------------------------------------------------------
    // ENREGISTRER / MODIFIER LE MONTANT
    // ------------------------------------------------------------

    const handleSaveMonthlyAmount = async () => {
      if (!selectedCaregiver) {
        toast.error(
          "Veuillez sélectionner un soignant."
        );
        return;
      }

      if (
        selectedMonthlyAmount === "" ||
        selectedMonthlyAmount === null ||
        Number.isNaN(Number(selectedMonthlyAmount)) ||
        Number(selectedMonthlyAmount) < 0
      ) {
        toast.error(
          "Veuillez introduire un montant valide."
        );
        return;
      }

      setSavingMonthlyAmount(true);

      try {
        const payload = {
          soignant_id: normalizeId(selectedCaregiver),
          mois: Number(selectedMonth),
          annee: Number(selectedYear),
          montant: Number(selectedMonthlyAmount)
        };

        console.log(
          "Montant mensuel envoyé :",
          payload
        );

        const response = await axiosInstance.put(
          "/montants-mensuels-soignants",
          payload
        );

        const montantEnregistre =
          response.data?.montant_mensuel?.montant ??
          Number(selectedMonthlyAmount);

        setMonthlyTotals((prev) => ({
          ...prev,
          [monthlyTotalKey]: montantEnregistre
        }));

        toast.success(
          "Montant mensuel enregistré avec succès."
        );

      } catch (err) {
        console.error(
          "Erreur enregistrement montant mensuel :",
          err.response?.data || err
        );

        toast.error(
          err.response?.data?.detail ||
          "Impossible d’enregistrer le montant mensuel."
        );

      } finally {
        setSavingMonthlyAmount(false);
      }
    };
    //
    useEffect(() => {
      if (!selectedCaregiver) {
        return;
      }

      fetchMonthlyAmount();
    }, [
      selectedCaregiver,
      selectedMonth,
      selectedYear
    ]);

  const fetchTrash = async () => {
    try {
      const res = await axiosInstance.get("/patients/trash");
      setTrashPatients(res.data);
      console.log("🗑 Patients archivés :", res.data.length);
    } catch (err) {
      console.error(err);
      toast.error("Erreur chargement corbeille");
    }
};

 
  const fetchPrestations = async () => {
  try {
    const res = await axiosInstance.get(
      "/prestations-domicile"
    );

    const prestationList = Array.isArray(res.data)
      ? res.data
      : res.data?.prestations || [];

    console.log(
      "Réponse /prestations-domicile :",
      prestationList
    );

    setPrestations(prestationList);

    return prestationList;
  } catch (err) {
    console.error(
      "Erreur chargement prestations :",
      err.response?.data || err
    );

    setPrestations([]);

    toast.error(
      err.response?.data?.detail ||
      "Erreur chargement prestations"
    );

    return [];
  }
};

 const fetchExternalCaregivers = async (code) => {
  try {
    const res = await axiosInstance.get(
      "/soignants-externes",
      {
        params: {
          code
        }
      }
    );

    const externalList = Array.isArray(res.data)
      ? res.data
      : res.data?.soignants ||
        res.data?.soignants_externes ||
        [];

    setExternalCaregivers(
      externalList.filter(
        (soignant) => soignant.actif !== false
      )
    );

    return true;
  } catch (err) {
    console.error(
      "Erreur chargement soignants externes :",
      err.response?.data || err
    );

    toast.error(
      err.response?.data?.detail ||
      "Impossible d’accéder aux soignants externes"
    );

    return false;
  }
};


const handleUnlockExternalCaregivers = async (e) => {
  e?.preventDefault();

  if (!externalCaregiversCode.trim()) {
    toast.error("Veuillez entrer le code administrateur");
    return;
  }

  setCheckingExternalCode(true);

  try {
    await axiosInstance.post(
      "/soignants-externes/verifier-code",
      {
        code: externalCaregiversCode.trim()
      }
    );

    const loaded = await fetchExternalCaregivers(
      externalCaregiversCode.trim()
    );

    if (loaded) {
      setExternalCaregiversUnlocked(true);
      toast.success("Accès aux soignants externes autorisé");
    }
  } catch (err) {
    toast.error(
      err.response?.data?.detail ||
      "Code incorrect"
    );
  } finally {
    setCheckingExternalCode(false);
  }
};

const getPlanningMonthInfo = () => {
  const [year, month] = planningMonth.split("-").map(Number);

  if (!year || !month) {
    return {
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      daysInMonth: 30,
      startOffset: 0
    };
  }

  const daysInMonth = new Date(year, month, 0).getDate();
  const firstDay = new Date(year, month - 1, 1).getDay();
  const startOffset = (firstDay + 6) % 7;

  return { year, month, daysInMonth, startOffset };
};

const formatPlanningDate = (day) => {
  const { year, month } = getPlanningMonthInfo();
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
};

const togglePlanningDate = (date) => {
  setPlanningDays((prev) => {
    if (Object.prototype.hasOwnProperty.call(prev, date)) {
      const next = { ...prev };
      delete next[date];
      return next;
    }

    return {
      ...prev,
      [date]: []
    };
  });
};

const togglePlanningPassage = (date, passage) => {
  setPlanningDays((prev) => {
    const currentPassages = Array.isArray(prev[date]) ? prev[date] : [];
    const alreadySelected = currentPassages.includes(passage);

    return {
      ...prev,
      [date]: alreadySelected
        ? currentPassages.filter((value) => value !== passage)
        : [...currentPassages, passage]
    };
  });
};

const selectAllPlanningPassages = (date) => {
  setPlanningDays((prev) => ({
    ...prev,
    [date]: ["matin", "midi", "soir"]
  }));
};

const applyPassagesToAllDates = (sourceDate) => {
  const sourcePassages = planningDays[sourceDate] || [];

  if (sourcePassages.length === 0) {
    toast.error("Sélectionnez d’abord au moins un créneau pour cette date.");
    return;
  }

  setPlanningDays((prev) =>
    Object.keys(prev).reduce((next, date) => {
      next[date] = [...sourcePassages];
      return next;
    }, {})
  );

  toast.success("Les mêmes créneaux ont été appliqués à toutes les dates sélectionnées.");
};

const clearPlanningDay = (date) => {
  setPlanningDays((prev) => {
    const next = { ...prev };
    delete next[date];
    return next;
  });
};

const getPatientDisplayName = (patient) =>
  `${patient?.prenom || patient?.first_name || ""} ${patient?.nom || patient?.last_name || ""}`.trim() ||
  "Patient sans nom";

const handleCreatePrestation = async (e) => {
  e.preventDefault();

  if (!canManagePrestations) {
    toast.error("Vous n’êtes pas autorisé à créer une prestation.");
    return;
  }

  if (
    newPrestation.caregiver_type === "registered" &&
    !newPrestation.soignant_id
  ) {
    toast.error("Veuillez choisir un soignant enregistré");
    return;
  }

  if (
    newPrestation.caregiver_type === "registered" &&
    !isValidCaregiverId(newPrestation.soignant_id)
  ) {
    toast.error("L’identifiant du soignant sélectionné est invalide.");
    return;
  }

  if (
    newPrestation.caregiver_type === "external" &&
    !newPrestation.soignant_externe_id
  ) {
    toast.error("Veuillez choisir un autre soignant");
    return;
  }

  if (
    newPrestation.caregiver_type === "external" &&
    !isMongoObjectId(newPrestation.soignant_externe_id)
  ) {
    toast.error("L’identifiant du soignant externe est invalide.");
    return;
  }

  if (!newPrestation.patient_id) {
    toast.error("Veuillez choisir un patient.");
    return;
  }

  const selectedDates = Object.keys(planningDays).sort();

  if (selectedDates.length === 0) {
    toast.error("Sélectionnez au moins une date dans le calendrier.");
    return;
  }

  const dateWithoutPassage = selectedDates.find(
    (date) => !Array.isArray(planningDays[date]) || planningDays[date].length === 0
  );

  if (dateWithoutPassage) {
    toast.error(
      `Sélectionnez Matin, Midi ou Soir pour le ${new Date(`${dateWithoutPassage}T12:00:00`).toLocaleDateString("fr-BE")}.`
    );
    return;
  }

  try {
    const selectedSoignantId =
      newPrestation.caregiver_type === "registered"
        ? String(newPrestation.soignant_id || "").trim()
        : null;

    const selectedExternalSoignantId =
      newPrestation.caregiver_type === "external"
        ? String(newPrestation.soignant_externe_id || "").trim()
        : null;

    const requests = selectedDates.map((date) => {
      const payload = {
        date,
        patient_id: String(newPrestation.patient_id).trim(),
        passages: planningDays[date],
        soignant_id: selectedSoignantId,
        soignant_externe_id: selectedExternalSoignantId,
        notes: newPrestation.notes?.trim() || ""
      };

      return axiosInstance.post("/prestations-domicile", payload);
    });

    const results = await Promise.allSettled(requests);
    const successfulRequests = results.filter(
      (result) => result.status === "fulfilled"
    );
    const failedRequests = results.filter(
      (result) => result.status === "rejected"
    );

    if (failedRequests.length === 0) {
      toast.success(
        `${successfulRequests.length} prestation(s) enregistrée(s) pour ce patient.`
      );
    } else if (successfulRequests.length > 0) {
      toast.warning(
        `${successfulRequests.length} prestation(s) enregistrée(s), ${failedRequests.length} ont échoué.`
      );
    } else {
      throw failedRequests[0]?.reason;
    }

    setNewPrestation(getEmptyPrestation());
    setPlanningDays({});
    setCreatingPrestation(false);

    await fetchPrestations();
  } catch (err) {
    console.error("Erreur création des prestations :", err);

    const backendDetail = err?.response?.data?.detail;

    toast.error(
      Array.isArray(backendDetail)
        ? backendDetail.map((item) => item.msg).join(" | ")
        : backendDetail ||
          err?.message ||
          "Erreur lors de la création des prestations"
    );
  }
};

const handleDeletePrestation = async (id) => {
  if (!canManagePrestations) {
    toast.error("Vous n’êtes pas autorisé à supprimer une prestation.");
    return;
  }

  if (!window.confirm("Supprimer cette prestation ?")) return;

  try {
    await axiosInstance.delete(`/prestations-domicile/${id}`);
    await fetchPrestations();
  } catch (err) {
    toast.error(
      err.response?.data?.detail ||
      "Erreur lors de la suppression"
    );
  }
};

const startEditPrestation = (prestation) => {
  if (!canManagePrestations) {
    toast.error("Vous n’êtes pas autorisé à modifier une prestation.");
    return;
  }

  setEditingPrestation(prestation._id);
  setCreatingPrestation(false);

  const patientId =
    prestation.patient_id?._id ||
    prestation.patient_id ||
    prestation.patient?._id ||
    "";

  const soignantId =
    prestation.soignant_id?._id ||
    prestation.soignant_id ||
    prestation.soignant?._id ||
    "";

  const soignantExterneId =
    prestation.soignant_externe_id?._id ||
    prestation.soignant_externe_id ||
    prestation.soignant_externe?._id ||
    "";

  setNewPrestation({
  date: prestation.date
    ? prestation.date.split("T")[0]
    : new Date().toISOString().split("T")[0],

  caregiver_type: soignantExterneId
    ? "external"
    : "registered",

  soignant_id: soignantId,
  soignant_externe_id: soignantExterneId,

  patients: [
    {
      patient_id: patientId,
      passages: Array.isArray(prestation.passages)
        ? prestation.passages
        : []
    }
  ],

  notes: prestation.notes || ""
});

  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
};

const handleUpdatePrestation = async (e) => {
  e.preventDefault();

  if (!canManagePrestations) {
    toast.error("Vous n’êtes pas autorisé à modifier une prestation.");
    return;
  }

  const selectedPatient =
  newPrestation.patients?.[0];

  if (!selectedPatient?.patient_id) {
    toast.error("Veuillez choisir un patient");
    return;
  }

  if (
    !Array.isArray(selectedPatient.passages) ||
    selectedPatient.passages.length === 0
  ) {
    toast.error(
      "Veuillez choisir au moins un passage"
    );
    return;
  }

  try {
    const payload = {
      date: newPrestation.date,
      patient_id: selectedPatient.patient_id,
      passages: selectedPatient.passages,

      soignant_id:
        newPrestation.caregiver_type === "registered"
          ? newPrestation.soignant_id
          : null,

      soignant_externe_id:
        newPrestation.caregiver_type === "external"
          ? newPrestation.soignant_externe_id
          : null,

      notes:
        newPrestation.notes?.trim() || ""
    };

    await axiosInstance.put(
      `/prestations-domicile/${editingPrestation}`,
      payload
    );

    toast.success("Prestation modifiée");

    setEditingPrestation(null);
    setNewPrestation(getEmptyPrestation());

    await fetchPrestations();
  } catch (err) {
    console.error("Erreur modification prestation :", err);

    toast.error(
      err.response?.data?.detail ||
      "Erreur lors de la modification"
    );
  }
}; 

  const fetchUsers = async () => {
    try {
      const res = await axiosInstance.get("/users");

      const userList = Array.isArray(res.data)
        ? res.data
        : res.data?.users || [];

      const caregivers = userList.filter(
        (u) =>
          ["nurse", "caregiver"].includes(u.role) &&
          u.status !== "rejected" &&
          u.status !== "deleted" &&
          u.archived !== true
      );

      const caregiversWithValidIds = caregivers.filter(
        (soignant) => {
          const soignantId = getEntityId(soignant);

          if (!isValidCaregiverId(soignantId)) {
            console.error(
              "Soignant ignoré : identifiant absent ou invalide",
              soignant
            );

            return false;
          }

          return true;
        }
      );

      setUsers(caregiversWithValidIds);

      console.log(
        "Soignants chargés :",
        caregiversWithValidIds
      );
    } catch (err) {
      console.error(
        "Erreur chargement soignants :",
        err.response?.data || err
      );

      toast.error(
        err.response?.data?.detail ||
        "Erreur chargement soignants"
      );
    }
  };
  

 const handleCreatePatient = async (e) => {
  e.preventDefault();

  try {
    const response = await axiosInstance.post('/patients', newPatient);

    const patientId =
      response.data?._id ||
      response.data?.id ||
      response.data?.patient?._id ||
      response.data?.patient?.id;

    if (!patientId) throw new Error("ID patient introuvable");

    if (canEditDocuments) {
      await Promise.allSettled([
        uploadPatientDocument(patientId, 'identity_card', patientDocs.identity_card),
        uploadPatientDocument(patientId, 'identity_card_back', patientDocs.identity_card_back),
        uploadPatientDocument(patientId, 'vignette', patientDocs.vignette),
        uploadPatientDocument(patientId, 'prescription_medicale', patientDocs.prescription_medicale),
        uploadPatientDocument(patientId, 'echelle_katz', patientDocs.echelle_katz),
        uploadPatientDocument(patientId, 'fiche_patient', patientDocs.fiche_patient),
      ]);
    }

    toast.success("Patient créé");
    setCreatingPatient(false);
    fetchPatients();
  } catch (err) {
    toast.error(err.response?.data?.detail || err.message || "Erreur création patient");
  }
};  

  const handleRequestAccess = async () => {
    try {
      await axiosInstance.post('/access-request');
      toast.success("Demande envoyée");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur");
    }
  };

  const normalizeAccessCode = (value) => {
  const cleaned = String(value || "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, "")
    .replace(/[–—−]/g, "-")
    .replace(/_/g, "-");

  // Autorise aussi ABCD1234 et le transforme en ABCD-1234.
  if (/^[A-Z0-9]{8}$/.test(cleaned)) {
    return `${cleaned.slice(0, 4)}-${cleaned.slice(4)}`;
  }

  return cleaned;
};

  const handleActivateAccess = async (e) => {
    e.preventDefault();

    const normalizedCode = normalizeAccessCode(accessCode);

    if (!normalizedCode) {
      toast.error("Veuillez introduire votre code d’accès.");
      return;
    }

    if (!/^[A-Z0-9]{4}-[A-Z0-9]{4}$/.test(normalizedCode)) {
      toast.error("Le code doit être au format XXXX-XXXX.");
      return;
    }

    try {
      console.log("Code envoyé :", JSON.stringify(normalizedCode));

      const response = await axiosInstance.post(
        "/access-request/activate",
        {
          code: normalizedCode
        }
      );

      toast.success(
        response.data?.message ||
        "Votre accès a été activé avec succès."
      );

      setAccessCode("");
      setAccessStatus("active");

      await fetchPatients();
    } catch (err) {
      console.error(
        "Erreur activation accès :",
        err.response?.status,
        err.response?.data || err
      );

      toast.error(
        err.response?.data?.detail ||
        "Impossible d’activer votre accès."
      );
    }
  };

 const renderAccessRequestPanel = () => (
  <Card className="border-[#d4ebeb] bg-[#f4fafa] shadow-sm">
    <CardContent className="p-6 space-y-5">
      <div>
        <h3 className="text-lg font-semibold text-[#315f63]">
          Activation de l’accès
        </h3>

        <p className="mt-2 text-sm text-[#4f7d80]">
          {accessStatus === "pending"
            ? "Introduisez le code reçu par e-mail."
            : "Envoyez une demande pour obtenir un code d’accès."}
        </p>
      </div>

      {accessStatus !== "pending" && (
        <Button
          type="button"
          onClick={handleRequestAccess}
          className="bg-[#6faeb2] hover:bg-[#5b979b] text-white"
        >
          Demander un accès
        </Button>
      )}

      <div className="border-t border-[#d4ebeb] pt-5">
        <form
          onSubmit={handleActivateAccess}
          className="space-y-3"
        >
          <div className="space-y-1">
            <Label htmlFor="patient-access-code">
              Code d’accès reçu
            </Label>

            <Input
              id="patient-access-code"
              type="text"
              placeholder="Exemple : ABCD-1234"
              value={accessCode}
              onChange={(e) => {
                setAccessCode(
                  normalizeAccessCode(e.target.value)
                );
              }}
              maxLength={9}
              autoComplete="one-time-code"
              autoCapitalize="characters"
              spellCheck={false}
              required
            />
          </div>

          <Button
            type="submit"
            className="bg-green-600 hover:bg-green-700 text-white"
          >
            Activer mon accès
          </Button>
        </form>
      </div>
    </CardContent>
  </Card>
);

  const handlePatientDocChange = (docName, file) => {
    setPatientDocs(prev => ({
      ...prev,
      [docName]: file
    }));
  };

const uploadPatientDocument = async (patientId, docName, file) => {
  if (!canEditDocuments) {
    toast.error("Accès refusé");
    return;
  }

  if (!file) {
    toast.error("Choisissez un fichier");
    return;
  }

  try {
    const formData = new FormData();
    formData.append('file', file);

    await axiosInstance.post(`/patients/${patientId}/upload/${docName}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    toast.success("Document téléversé");
    fetchPatients();
  } catch {
    toast.error("Erreur upload document");
  }
};



const handleOpenDomicilePayroll = () => {
  if (!selectedCaregiver) {
    toast.error(
      "Veuillez sélectionner un soignant."
    );
    return;
  }

  navigate(
    `/domicile-payrolls/${normalizeId(
      selectedCaregiver
    )}?month=${selectedMonth}&year=${selectedYear}`
  );
};

const getEntityId = (item) => {
  if (!item) return "";

  return String(
    item.id ||
    item._id ||
    item.user_id ||
    ""
  ).trim();
};

const isUuid = (value) => {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    String(value || "").trim()
  );
};

const isValidCaregiverId = (value) => {
  const cleanValue = String(value || "").trim();

  return (
    /^[a-fA-F0-9]{24}$/.test(cleanValue) ||
    isUuid(cleanValue)
  );
};

const isMongoObjectId = (value) => {
  return /^[a-fA-F0-9]{24}$/.test(
    String(value || "").trim()
  );
};

const getRoleLabel = (person) => {
  if (person?.role === "nurse") {
    return "Infirmier(ère)";
  }

  if (person?.role === "caregiver") {
    return "Aide-soignant(e)";
  }

  if (person?.care_role) {
    return person.care_role;
  }

  return "Soignant externe";
};



  const openPatientCare = (patient) => {
    if (!patient?._id) {
      toast.error("Identifiant du patient introuvable.");
      return;
    }

    const patientId = String(patient._id).trim();

    const patientPrestations = prestations.filter(
      (prestation) => {
        const prestationPatientId = String(
          prestation?.patient?._id ||
          prestation?.patient_id?._id ||
          prestation?.patient_id ||
          ""
        ).trim();

        return prestationPatientId === patientId;
      }
    );

    console.log(
      "Patient envoyé vers la fiche de soins :",
      patient
    );

    console.log(
      "Prestations envoyées vers la fiche de soins :",
      patientPrestations
    );

    navigate(`/soins/patient/${patientId}`, {
      state: {
        patient,
        prestations: patientPrestations
      }
    });
  };

  const renderDocumentLink = (doc, label) => {
    if (!doc || !doc.url) return <span className="text-[#6faeb2]">Non fourni</span>;

    return (
      <a
        href={doc.url}
        target="_blank"
        rel="noreferrer"
        className="inline-flex items-center gap-1 text-[#4f7d80] hover:text-[#315f63] underline"
      >
        <Eye size={14} /> Voir
      </a>
    );
  };

  if (loadingPatients) {
  return (
    <Layout title="Soins à domicile">
      <div className="p-8 text-center text-[#3d6d71]">
        Chargement des patients…
      </div>
    </Layout>
  );
}

if (!isAdminOrCoordinator && accessStatus === "loading") {
  return (
    <Layout title="Soins à domicile">
      <div className="p-8 text-center text-[#3d6d71]">
        Vérification de votre autorisation…
      </div>
    </Layout>
  );
}
if (!isAdminOrCoordinator && accessStatus === "pending") {
  return (
    <Layout title="Soins à domicile">
      <div className="space-y-6">
        <Card className="border-[#d4ebeb] bg-[#f4fafa]">
          <CardContent className="p-6 text-center space-y-3">
            <p className="font-semibold text-[#315f63]">
              Votre demande d’accès a bien été envoyée.
            </p>

            <p className="text-sm text-[#4f7d80]">
              Introduisez ci-dessous le code reçu par e-mail pour activer
              votre accès.
            </p>
          </CardContent>
        </Card>

        {renderAccessRequestPanel()}
      </div>
    </Layout>
  );
}
if (
  !isAdminOrCoordinator &&
  accessStatus === "active" &&
  patients.length === 0
) {
  return (
    <Layout title="Soins à domicile">
      <Card className="border-[#d4ebeb] bg-[#f4fafa]">
        <CardContent className="p-6 text-center space-y-3">
          <p className="font-semibold text-[#315f63]">
            Votre accès est actif, mais aucun patient ne vous est actuellement attribué.
          </p>
        </CardContent>
      </Card>
    </Layout>
  );
}

// if (!isAdminOrCoordinator && patients.length === 0) {
if (!isAdminOrCoordinator && accessStatus === "none") {
  return (
    <Layout title="Soins à domicile">
      <div className="mb-10">
        <div className="flex items-center gap-4">
          <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#b8dede] to-[#83bfc1]" />

          <div className="rounded-full bg-[#6faeb2] px-8 py-3 shadow-lg">
            <h1 className="text-3xl font-bold text-white tracking-wide">
              🏠 Soins à domicile
            </h1>
          </div>

          <div className="h-px flex-1 bg-gradient-to-l from-transparent via-[#b8dede] to-[#83bfc1]" />
        </div>
      </div>

      <div className="space-y-6">
        <Card className="border-[#d4ebeb] bg-[#f4fafa]">
          <CardContent className="p-6 text-center space-y-3">
            <p className="font-semibold text-[#315f63]">
              Aucun patient ne vous est actuellement assigné.
            </p>

            
          </CardContent>
        </Card>

        {renderAccessRequestPanel()}
      </div>
    </Layout>
  );
}

  return (
    <Layout>
      <div className="mb-10">
        <div className="flex items-center gap-4">
          <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#b8dede] to-[#83bfc1]"></div>

          <div className="rounded-full bg-[#6faeb2] px-8 py-3 shadow-lg">
            <h1 className="text-3xl font-bold text-white tracking-wide">
              🏠 Soins à domicile
            </h1>
          </div>

          <div className="h-px flex-1 bg-gradient-to-l from-transparent via-[#b8dede] to-[#83bfc1]"></div>
        </div>

        <p className="mt-4 text-center text-[#4f7d80] text-sm">
          Gestion des patients, des prestations à domicile.
        </p>
      </div>
      <div className="space-y-8 text-[#24494c]">
        
        {(user.role === "admin" || user.care_role === "coordinateur") && (
          <AccessRequestsAdmin />
        )}
        {!isAdminOrCoordinator && accessStatus === "none" && (
          <div className="mb-6">
            {renderAccessRequestPanel()}
          </div>
        )}

      
        {isAdminOrCoordinator && (
  <>
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-semibold text-[#3d6d71]">Gestion des Patients</h2>
          <Button
            onClick={() => setCreatingPatient(!creatingPatient)}
            className="bg-[#6faeb2] hover:bg-[#5b979b] text-white flex items-center"
          >
            <PlusCircle className="mr-2" size={18} /> Nouveau patient
          </Button>
        </div>
          <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-4 mb-8">
            <Card className="shadow-md border-0">
              <CardContent className="p-5">
                <p className="text-gray-500 text-sm">Total Patients</p>
                <p className="text-3xl font-bold">{patientStats.total}</p>
              </CardContent>
            </Card>

            <Card className="shadow-md border-0">
              <CardContent className="p-5">
                <p className="text-gray-500 text-sm">Actifs</p>
                <p className="text-3xl font-bold text-green-600">
                {patientStats.actifs}
                </p>
              </CardContent>
            </Card>

            <Card className="shadow-md border-0">
              <CardContent className="p-5">
                <p className="text-gray-500 text-sm">Archivés</p>
                <p className="text-3xl font-bold text-[#6faeb2]">
                {patientStats.archives}
                </p>
              </CardContent>
            </Card>

            <Card className="shadow-md border-0">
              <CardContent className="p-5">
                <p className="text-gray-500 text-sm">Avec Mutuelle</p>
                <p className="text-3xl font-bold text-blue-600">
                {patientStats.mutuelle}
                </p>
              </CardContent>
            </Card>

            <Card className="shadow-md border-0">
              <CardContent className="p-5">
                <p className="text-gray-500 text-sm">Sans mutuelle</p>
                <p className="text-3xl font-bold text-red-600">
                {patientStats.sansMutuelle}
                </p>
              </CardContent>
            </Card>
            </div>

        <div className="flex gap-2">
          <Button onClick={() => setShowTrash(false)}
            className="bg-[#6faeb2] hover:bg-[#5b979b] text-white flex items-center">
            Patients actifs
          </Button>

          <Button
            onClick={() => {
              setShowTrash(true);
              fetchTrash();
            }}
            className="bg-[#6faeb2] hover:bg-[#5b979b] text-white flex items-center"
          >
            Corbeille
          </Button>
        </div>

        {showTrash && (
          <div className="mt-4 space-y-2">
            {trashPatients.length === 0 ? (
              <p className="text-[#4f7d80]">Corbeille vide</p>
            ) : (
              trashPatients.map((p) => (
                <Card key={p._id} className="border-red-200 bg-red-50">
                  <CardContent className="p-4 flex justify-between items-center">
                    <div>
                      <p className="font-semibold">
                        {p.nom} {p.prenom}
                      </p>
                      <p className="text-sm text-gray-600">
                        Archivé le{" "}
                        {p.archived_at
                          ? new Date(p.archived_at).toLocaleDateString()
                          : "-"}
                      </p>
                    </div>

                    <Button
                      onClick={() => handleRestorePatient(p._id)}
                      className="bg-green-600 hover:bg-green-700 text-white"
                    >
                      Restaurer
                    </Button>
                    
                  </CardContent>
                </Card>
              ))
            )}
          </div>
        )}

        {creatingPatient && (
          <Card className="glass-card border-[#d4ebeb] bg-[#f4fafa]">
            <CardContent className="p-4">
              <form onSubmit={handleCreatePatient} className="grid gap-4">
                <Input
                  placeholder="Nom"
                  value={newPatient.nom}
                  onChange={e => setNewPatient({ ...newPatient, nom: e.target.value })}
                  required
                />
                <Input
                  placeholder="Prénom"
                  value={newPatient.prenom}
                  onChange={e => setNewPatient({ ...newPatient, prenom: e.target.value })}
                  required
                />
                <Input
                  placeholder="Adresse"
                  value={newPatient.adresse}
                  onChange={e => setNewPatient({ ...newPatient, adresse: e.target.value })}
                />
                <Input
                  placeholder="Téléphone"
                  value={newPatient.telephone}
                  onChange={e => setNewPatient({ ...newPatient, telephone: e.target.value })}
                />
                <Input
                  placeholder="Email"
                  value={newPatient.email}
                  onChange={e => setNewPatient({ ...newPatient, email: e.target.value })}
                  type="email"
                />
                <Input
                  placeholder="Numéro national"
                  value={newPatient.numero_national}
                  onChange={e => setNewPatient({ ...newPatient, numero_national: e.target.value })}
                />

                <div className="space-y-1">
                  <Label>Date de naissance</Label>
                  <Input
                    type="date"
                    value={newPatient.date_naissance}
                    onChange={e => setNewPatient({ ...newPatient, date_naissance: e.target.value })}
                  />
                </div>

                <div className="space-y-1">
                  <Label>Date de début</Label>
                  <Input
                    type="date"
                    value={newPatient.date_debut}
                    onChange={e => setNewPatient({ ...newPatient, date_debut: e.target.value })}
                  />
                </div>

                <div className="space-y-1">
                  <Label>Date de fin</Label>
                  <Input
                    type="date"
                    value={newPatient.date_fin}
                    onChange={e => setNewPatient({ ...newPatient, date_fin: e.target.value })}
                  />
                </div>

                <div className="space-y-1">
                  <Label>Assurabilité</Label>
                  <select
                    className="border rounded-md px-3 py-2 bg-white text-[#24494c] border-[#d4ebeb]"
                    value={newPatient.assurabilite}
                    onChange={e => setNewPatient({ ...newPatient, assurabilite: e.target.value })}
                  >
                    <option value="mutuelle">Mutuelle</option>
                    <option value="sans_mutuelle">Sans mutuelle</option>
                  </select>
                </div>

                {canEditDocuments && (
                  <div className="border border-[#d4ebeb] rounded-xl p-4 bg-white space-y-4">
                    <h3 className="font-semibold text-[#3d6d71] flex items-center gap-2">
                      <FileText size={18} /> Documents du patient
                    </h3>

                    <div className="space-y-2">
                      <Label>Carte d’identité (recto)</Label>
                      <Input
                        type="file"
                        onChange={(e) => {
                          const file = e.target.files?.[0] || null;
                          handlePatientDocChange('identity_card', file);
                        }}
                      />
                    </div>

                    <div className="space-y-2">
                      <Label>Carte d’identité (verso)</Label>
                      <Input
                        type="file"
                        onChange={(e) => {
                          const file = e.target.files?.[0] || null;
                          handlePatientDocChange('identity_card_back', file);
                        }}
                      />
                    </div>

                    <div className="space-y-2">
                      <Label>Vignette</Label>
                      <Input
                        type="file"
                        onChange={(e) => {
                          const file = e.target.files?.[0] || null;
                          handlePatientDocChange('vignette', file);
                        }}
                      />
                    </div>

                    <div className="space-y-2">
                      <Label>Prescription médicale</Label>
                      <Input
                        type="file"
                        onChange={(e) => {
                          const file = e.target.files?.[0] || null;
                          handlePatientDocChange('prescription_medicale', file);
                        }}
                      />
                    </div>

                    <div className="space-y-2">
                      <Label>Échelle de Katz</Label>
                      <Input
                        type="file"
                        onChange={(e) => {
                          const file = e.target.files?.[0] || null;
                          handlePatientDocChange('echelle_katz', file);
                        }}
                      />
                    </div>

                    <div className="space-y-2">
                      <Label>Fiche patient</Label>
                      <Input
                        type="file"
                        onChange={(e) => {
                          const file = e.target.files?.[0] || null;
                          handlePatientDocChange('fiche_patient', file);
                        }}
                      />
                    </div>

                    <div className="space-y-2">
                      <Label>Description des documents</Label>
                      <Input
                        placeholder="Ex: documents scannés, version papier, photo..."
                        value={newPatient.description_documents}
                        onChange={e => setNewPatient({ ...newPatient, description_documents: e.target.value })}
                      />
                    </div>

                    <p className="text-sm text-[#4f7d80]">
                      Les fichiers seront envoyés après création du patient.
                    </p>
                  </div>
                )}

                <Button type="submit" className="bg-[#6faeb2] hover:bg-[#5b979b] text-white">
                  Créer
                </Button>
              </form>
            </CardContent>
          </Card>
        )}

        {editingPatient && (
          <Card className="glass-card border-[#d4ebeb] bg-[#f4fafa]">
            <CardContent className="p-4">
              <div className="flex items-center gap-2 mb-4">
                <h3 className="text-base font-medium text-[#3d6d71]">Modifier le patient</h3>
                <Button
                  onClick={() => setEditingPatient(null)}
                  className="text-xs px-2 py-1 bg-slate-200 text-slate-800"
                >
                  Annuler
                </Button>
              </div>

              <form onSubmit={handleUpdatePatient} className="grid gap-4">
                <Input
                  placeholder="Nom"
                  value={newPatient.nom}
                  onChange={e => setNewPatient({ ...newPatient, nom: e.target.value })}
                  required
                />
                <Input
                  placeholder="Prénom"
                  value={newPatient.prenom}
                  onChange={e => setNewPatient({ ...newPatient, prenom: e.target.value })}
                  required
                />
                <Input
                  placeholder="Adresse"
                  value={newPatient.adresse}
                  onChange={e => setNewPatient({ ...newPatient, adresse: e.target.value })}
                />
                <Input
                  placeholder="Téléphone"
                  value={newPatient.telephone}
                  onChange={e => setNewPatient({ ...newPatient, telephone: e.target.value })}
                />
                <Input
                  placeholder="Email"
                  value={newPatient.email}
                  onChange={e => setNewPatient({ ...newPatient, email: e.target.value })}
                  type="email"
                />
                <Input
                  placeholder="Numéro national"
                  value={newPatient.numero_national}
                  onChange={e => setNewPatient({ ...newPatient, numero_national: e.target.value })}
                />

                <div className="space-y-1">
                  <Label>Date de naissance</Label>
                  <Input
                    type="date"
                    value={newPatient.date_naissance}
                    onChange={e => setNewPatient({ ...newPatient, date_naissance: e.target.value })}
                  />
                </div>

                <div className="space-y-1">
                  <Label>Date de début</Label>
                  <Input
                    type="date"
                    value={newPatient.date_debut}
                    onChange={e => setNewPatient({ ...newPatient, date_debut: e.target.value })}
                  />
                </div>

                <div className="space-y-1">
                  <Label>Date de fin</Label>
                  <Input
                    type="date"
                    value={newPatient.date_fin}
                    onChange={e => setNewPatient({ ...newPatient, date_fin: e.target.value })}
                  />
                </div>

                <div className="space-y-1">
                  <Label>Assurabilité</Label>
                  <select
                    className="border rounded-md px-3 py-2 bg-white text-[#24494c] border-[#d4ebeb]"
                    value={newPatient.assurabilite}
                    onChange={e => setNewPatient({ ...newPatient, assurabilite: e.target.value })}
                  >
                    <option value="mutuelle">Mutuelle</option>
                    <option value="sans_mutuelle">Sans mutuelle</option>
                  </select>
                </div>


                <Button type="submit" className="bg-[#6faeb2] hover:bg-[#5b979b] text-white">
                  Mettre à jour
                </Button>
              </form>
            </CardContent>
          </Card>
        )}
      </>   
)}


        <div className="mt-6">
  <h3 className="text-lg font-medium text-[#3d6d71] mb-3">
    {isAdminOrCoordinator
      ? "Patients enregistrés"
      : "Mes patients assignés"}
  </h3>

  {(() => {
    const displayPatients = filteredPatients;

    if (displayPatients.length === 0) {
      return (
        <p className="text-[#4f7d80]">
          Aucun patient enregistré.
        </p>
      );
    }

    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {filteredPatients.map((p) => (
          <Card key={p._id} className="border-[#d4ebeb] bg-[#f4fafa]">
            <CardContent className="p-4">

              {/* En-tête cliquable */}
              <div
                onClick={() =>
                  setOpenedPatient(openedPatient === p._id ? null : p._id)
                }
                className="flex justify-between items-center cursor-pointer"
              >
                <div>
                  <p className="font-semibold text-[#315f63] text-lg">
                    {p.nom} {p.prenom}
                  </p>

                  <p className="text-sm text-[#4f7d80]">
                    📍 {p.adresse || "-"}
                  </p>

                  <p className="text-sm text-[#4f7d80]">
                    📞 {p.telephone || "-"}
                  </p>
                </div>

                <span className="text-2xl font-bold text-[#4f7d80]">
                  {openedPatient === p._id ? "▲" : "▼"}
                </span>
              </div>

              {/* Contenu déroulant */}
              {openedPatient === p._id && (
                <div className="mt-4 border-t pt-4 space-y-4">

                  <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">

                    <div>
                      <span className="font-medium text-[#3d6d71]">Email :</span>
                      <p>{p.email || "-"}</p>
                    </div>

                    <div>
                      <span className="font-medium text-[#3d6d71]">
                        N° national :
                      </span>
                      <p>{p.numero_national || "-"}</p>
                    </div>

                    <div>
                      <span className="font-medium text-[#3d6d71]">
                        Date de naissance :
                      </span>
                      <p>
                        {p.date_naissance
                          ? new Date(p.date_naissance).toLocaleDateString()
                          : "-"}
                      </p>
                    </div>

                    <div>
                      <span className="font-medium text-[#3d6d71]">
                        Date de début :
                      </span>
                      <p>
                        {p.date_debut
                          ? new Date(p.date_debut).toLocaleDateString()
                          : "-"}
                      </p>
                    </div>

                    <div>
                      <span className="font-medium text-[#3d6d71]">
                        Date de fin :
                      </span>
                      <p>
                        {p.date_fin
                          ? new Date(p.date_fin).toLocaleDateString()
                          : "-"}
                      </p>
                    </div>

                    <div>
                      <span className="font-medium text-[#3d6d71]">
                        Assurabilité :
                      </span>
                      <p>{p.assurabilite || "-"}</p>
                    </div>

                  </div>

                  {/* Documents */}
                  <div className="border-t pt-4">
                    <h4 className="font-semibold text-[#3d6d71] mb-3">
                      Documents
                    </h4>

                    <div className="grid gap-3">

                      {[
                        {
                          key: "identity_card",
                          label: "Carte d’identité (recto)",
                          doc: p.documents?.identity_card,
                        },
                        {
                          key: "identity_card_back",
                          label: "Carte d’identité (verso)",
                          doc: p.documents?.identity_card_back,
                        },
                        {
                          key: "vignette",
                          label: "Vignette",
                          doc: p.documents?.vignette,
                        },
                        {
                          key: "prescription_medicale",
                          label: "Prescription médicale",
                          doc: p.documents?.prescription_medicale,
                        },
                        {
                          key: "echelle_katz",
                          label: "Échelle de Katz",
                          doc: p.documents?.echelle_katz,
                        },
                        {
                          key: "fiche_patient",
                          label: "Fiche patient",
                          doc: p.documents?.fiche_patient,
                        },
                      ].map((item) => (
                        <div
                          key={item.key}
                          className="flex justify-between items-center rounded-lg border border-[#e6f3f3] bg-white p-3"
                        >
                          <div className="flex items-center gap-3">
                            <span>{item.label}</span>

                            <span
                              className={`rounded-full px-2 py-1 text-xs font-semibold ${
                                item.doc?.url
                                  ? "bg-green-100 text-green-700"
                                  : "bg-red-100 text-red-700"
                              }`}
                            >
                              {item.doc?.url ? "Présent" : "Manquant"}
                            </span>
                          </div>

                          <div className="flex gap-2">

                            {renderDocumentLink(item.doc)}

                            {canEditDocuments && (
                              <>
                                <Button
                                  type="button"
                                  onClick={() => {
                                    document
                                      .getElementById(`${item.key}-${p._id}`)
                                      ?.click();
                                  }}
                                  // className="text-xs bg-[#f4fafa]0 hover:bg-[#6faeb2] text-white"
                                  className="bg-[#6faeb2] hover:bg-[#4f8f94] text-white transition-colors duration-200"
                                >
                                  Modifier
                                </Button>

                                <input
                                  id={`${item.key}-${p._id}`}
                                  type="file"
                                  className="hidden"
                                  accept=".pdf,.jpg,.jpeg,.png"
                                  onChange={async (e) => {
                                    const file = e.target.files?.[0];
                                    if (!file) return;

                                    await uploadPatientDocument(
                                      p._id,
                                      item.key,
                                      file
                                    );

                                    e.target.value = "";
                                  }}
                                />
                              </>
                            )}

                          </div>
                        </div>
                      ))}

                    </div>

                    {p.description_documents && (
                      <p className="mt-3 text-sm text-[#4f7d80]">
                        <b>Description :</b> {p.description_documents}
                      </p>
                    )}
                  </div>

                  {/* Accès à la fiche de soins */}
                  {!showTrash && (
                    <div className="pt-2">
                      <Button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          openPatientCare(p);
                        }}
                        className="w-full bg-[#315f63] hover:bg-[#24494c] text-white"
                      >
                        🩺 Voir les soins
                      </Button>
                    </div>
                  )}

                  {/* Boutons administratifs */}
                {canManagePatients && (
                <div className="flex gap-2 pt-2">
                  <Button
                    type="button"
                    onClick={() => startEditPatient(p)}
                    // className="bg-[#f4fafa]0 hover:bg-[#6faeb2] text-white"
                    className="bg-[#6faeb2] hover:bg-[#4f8f94] text-white transition-colors duration-200"
                  >
                    Modifier
                  </Button>

                  <Button
                    type="button"
                    onClick={() => handleArchivePatient(p._id)}
                    className="bg-[#6faeb2] hover:bg-[#5b979b] text-white"
                  >
                    Archiver
                  </Button>
                </div>
              )}

                </div>
              )}

            </CardContent>
          </Card>
          
        ))}
        
      </div>
      
    );
    
      })()}
      {isAdminOrCoordinator && (
  <>
      <div className="my-12">
      <div className="flex items-center gap-4">
        <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#b8dede] to-[#83bfc1]"></div>

        <div className="rounded-full bg-[#6faeb2] px-6 py-2 shadow-md">
          <span className="text-lg font-bold text-white">
            Prestations à domicile
          </span>
        </div>

        <div className="h-px flex-1 bg-gradient-to-l from-transparent via-[#b8dede] to-[#83bfc1]"></div>
      </div>
    </div>
    {/* {canManagePrestations && ( */}

      <section className="space-y-5">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>

        </div>

        

        {canManagePrestations && (
      <Button
        type="button"
        onClick={() => {
          setCreatingPrestation(!creatingPrestation);
          setEditingPrestation(null);
          setNewPrestation(getEmptyPrestation());
          setPlanningDays({});
        }}
        className="bg-[#6faeb2] hover:bg-[#5b979b] text-white"
      >
        <PlusCircle className="mr-2" size={18} />

        {creatingPrestation
          ? "Fermer"
          : "Nouvelle prestation"}
      </Button>
    )}
      </div>
{isAdminOrCoordinator && (
  <Card className="border-[#d4ebeb] bg-[#f4fafa] mt-8">
    <CardContent className="p-6 space-y-6">

      <div>
        <h3 className="text-xl font-semibold text-[#315f63]">
          📊 Prestations mensuelles par soignant
        </h3>

        <p className="text-sm text-[#4f7d80] mt-1">
          Sélectionnez une année, un mois puis un soignant pour afficher
          toutes ses prestations à domicile.
        </p>
      </div>

      {/* FILTRES */}
      {/* <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
       */}
       <div className="grid grid-cols-1 gap-4 md:grid-cols-4">

        {/* ANNÉE */}
        <div className="space-y-1">
          <Label>Année</Label>

          <Input
            type="number"
            value={selectedYear}
            onChange={(e) => {
              setSelectedYear(e.target.value);
              setSelectedCaregiver("");
            }}
          />
        </div>

        {/* MOIS */}
        <div className="space-y-1">
          <Label>Mois</Label>

          <select
            value={selectedMonth}
            onChange={(e) => {
              setSelectedMonth(e.target.value);
              setSelectedCaregiver("");
            }}
            className="w-full rounded-md border border-[#d4ebeb] bg-white px-3 py-2"
          >
            <option value="01">Janvier</option>
            <option value="02">Février</option>
            <option value="03">Mars</option>
            <option value="04">Avril</option>
            <option value="05">Mai</option>
            <option value="06">Juin</option>
            <option value="07">Juillet</option>
            <option value="08">Août</option>
            <option value="09">Septembre</option>
            <option value="10">Octobre</option>
            <option value="11">Novembre</option>
            <option value="12">Décembre</option>
          </select>
        </div>

        {/* SOIGNANT */}
        <div className="space-y-1">
          <Label>Soignant</Label>

          <select
            value={selectedCaregiver}
            onChange={(e) =>
              setSelectedCaregiver(e.target.value)
            }
            className="w-full rounded-md border border-[#d4ebeb] bg-white px-3 py-2"
          >
            <option value="">
              Sélectionner un soignant
            </option>

            {users.map((soignant) => {
              const soignantId = getEntityId(soignant);

              return (
                <option
                  key={soignantId}
                  value={soignantId}
                >
                  {getFullName(soignant)} — {getRoleLabel(soignant)}
                </option>
              );
            })}
          </select>
        </div>
      </div>

      {/* AUCUN SOIGNANT SELECTIONNÉ */}
      {!selectedCaregiver && (
        <div className="rounded-xl border border-[#d4ebeb] bg-white p-6 text-center">
          <p className="font-medium text-[#315f63]">
            👆 Sélectionnez un soignant pour afficher ses prestations.
          </p>
        </div>
      )}

      {/* SOIGNANT SÉLECTIONNÉ */}
      {selectedCaregiver && (
        <>
          {selectedCaregiverPrestations.length === 0 ? (
            <div className="rounded-xl border border-[#d4ebeb] bg-white p-6 text-center">
              <p className="text-[#4f7d80]">
                Aucune prestation trouvée pour ce soignant durant ce mois.
              </p>
            </div>
          ) : (
            <div className="space-y-5">

              {/* RESUME */}
              <div className="grid grid-cols-1 gap-4 md:grid-cols-3">

                <div className="rounded-xl border border-[#d4ebeb] bg-white p-4">
                  <p className="text-sm text-gray-500">
                    Soignant
                  </p>

                  <p className="text-lg font-bold text-[#315f63]">
                    {
                      monthlyCaregivers.find(
                        (caregiver) =>
                          caregiver.caregiverId === selectedCaregiver
                      )?.caregiverName || "Soignant"
                    }
                  </p>
                </div>

                <div className="rounded-xl border border-[#d4ebeb] bg-white p-4">
                  <p className="text-sm text-gray-500">
                    Nombre de prestations
                  </p>

                  <p className="text-2xl font-bold text-[#315f63]">
                    {selectedCaregiverPrestations.length}
                  </p>
                </div>

                <div className="rounded-xl border border-[#d4ebeb] bg-white p-4">
                  <p className="text-sm text-gray-500">
                    Nombre de passages
                  </p>

                  <p className="text-2xl font-bold text-[#315f63]">
                    {selectedCaregiverPrestations.reduce(
                      (total, prestation) =>
                        total +
                        (Array.isArray(prestation.passages)
                          ? prestation.passages.length
                          : 0),
                      0
                    )}
                  </p>
                </div>
                {/* <div className="rounded-xl border border-green-200 bg-green-50 p-4"> */}
                  <div className="rounded-xl border border-[#D4EBEB] bg-[#F1F8F8] p-4">
                  <p className="text-sm text-gray-500">
                    Montant total du mois
                  </p>

                  {loadingMonthlyAmount ? (
                    <p className="mt-3 text-sm text-green-700">
                      Chargement du montant…
                    </p>
                  ) : (
                    <>
                      <div className="mt-2 flex items-center gap-2">
                        <Input
                          type="number"
                          min="0"
                          step="0.01"
                          placeholder="Ex : 2850.00"
                          value={selectedMonthlyAmount}
                          onChange={(e) =>
                            handleMonthlyAmountChange(
                              e.target.value
                            )
                          }
                          className="bg-white"
                        />

                        <span className="text-xl font-bold text-[#3F6F72]">
                          €
                        </span>
                      </div>

                      <Button
                        type="button"
                        onClick={handleSaveMonthlyAmount}
                        disabled={savingMonthlyAmount}
                        className="mt-3 w-full bg-[#3F6F72] hover:bg-[#315B5D] text-white"
                      >
                        {savingMonthlyAmount
                          ? "Enregistrement..."
                          : "Enregistrer le montant"}
                      </Button>
                      <Button
                        type="button"
                        onClick={handleOpenDomicilePayroll}
                        disabled={!selectedCaregiver}
                        className="
                          mt-2
                          w-full
                          bg-[#3F6F72]
                          hover:bg-[#315B5D]
                          text-white
                        "
                      >
                        📄 Voir la fiche de rémunération
                      </Button>
                    </>
                  )}
                </div>

              </div>

              {/* TABLEAU */}
              <div className="overflow-x-auto rounded-xl border border-[#d4ebeb] bg-white">

                <table className="w-full border-collapse">

                  <thead className="bg-[#e6f3f3]">
                    <tr>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-[#315f63]">
                        Date
                      </th>

                      <th className="px-4 py-3 text-left text-sm font-semibold text-[#315f63]">
                        Patient
                      </th>

                      <th className="px-4 py-3 text-center text-sm font-semibold text-[#315f63]">
                        🌅 Matin
                      </th>

                      <th className="px-4 py-3 text-center text-sm font-semibold text-[#315f63]">
                        ☀️ Midi
                      </th>

                      <th className="px-4 py-3 text-center text-sm font-semibold text-[#315f63]">
                        🌙 Soir
                      </th>

                      <th className="px-4 py-3 text-left text-sm font-semibold text-[#315f63]">
                        Notes
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {selectedCaregiverPrestations.map(
                      (prestation, index) => {

                        const patient =
                          prestation.patient ||
                          prestation.patient_id;

                        const patientName =
                          patient &&
                          typeof patient === "object"
                            ? `${
                                patient.prenom ||
                                patient.first_name ||
                                ""
                              } ${
                                patient.nom ||
                                patient.last_name ||
                                ""
                              }`.trim()
                            : "Patient inconnu";

                        const passages =
                          Array.isArray(prestation.passages)
                            ? prestation.passages
                            : [];

                        return (
                          <tr
                            key={
                              prestation._id ||
                              prestation.id ||
                              index
                            }
                            className="border-t border-[#e6f3f3] hover:bg-[#f4fafa]"
                          >
                            {/* DATE */}
                            <td className="px-4 py-3 font-medium">
                              {new Date(
                                prestation.date
                              ).toLocaleDateString("fr-BE")}
                            </td>

                            {/* PATIENT */}
                            <td className="px-4 py-3 font-semibold text-[#315f63]">
                              {patientName}
                            </td>

                            {/* MATIN */}
                            <td className="px-4 py-3 text-center">
                              {passages.includes("matin") ? (
                                <span className="inline-flex rounded-full bg-green-100 px-3 py-1 font-semibold text-green-700">
                                  ✓ Matin
                                </span>
                              ) : (
                                <span className="text-gray-300">
                                  —
                                </span>
                              )}
                            </td>

                            {/* MIDI */}
                            <td className="px-4 py-3 text-center">
                              {passages.includes("midi") ? (
                                <span className="inline-flex rounded-full bg-green-100 px-3 py-1 font-semibold text-green-700">
                                  ✓ Midi
                                </span>
                              ) : (
                                <span className="text-gray-300">
                                  —
                                </span>
                              )}
                            </td>

                            {/* SOIR */}
                            <td className="px-4 py-3 text-center">
                              {passages.includes("soir") ? (
                                <span className="inline-flex rounded-full bg-green-100 px-3 py-1 font-semibold text-green-700">
                                  ✓ Soir
                                </span>
                              ) : (
                                <span className="text-gray-300">
                                  —
                                </span>
                              )}
                            </td>

                            {/* NOTES */}
                            <td className="px-4 py-3 text-sm text-gray-600">
                              {prestation.notes || "—"}
                            </td>
                          </tr>
                        );
                      }
                    )}
                  </tbody>

                </table>
              </div>
            </div>
          )}
        </>
      )}

    </CardContent>
  </Card>
)}

  {creatingPrestation && (
    <Card className="border-[#d4ebeb] bg-[#f4fafa]">
      <CardContent className="p-5">
        <form
          onSubmit={handleCreatePrestation}
          className="grid grid-cols-1 gap-5 md:grid-cols-2"
        >
          <div className="space-y-1 md:col-span-2">
            <Label>Type de soignant</Label>
            <div className="grid grid-cols-2 gap-3">
              <Button
                type="button"
                onClick={() =>
                  setNewPrestation((prev) => ({
                    ...prev,
                    caregiver_type: "registered",
                    soignant_externe_id: ""
                  }))
                }
                className={
                  newPrestation.caregiver_type === "registered"
                    ? "bg-[#6faeb2] text-white hover:bg-[#5b979b]"
                    : "bg-white text-[#3d6d71] border border-[#b8dede]"
                }
              >
                Soignants enregistrés
              </Button>

              <Button
                type="button"
                onClick={() =>
                  setNewPrestation((prev) => ({
                    ...prev,
                    caregiver_type: "external",
                    soignant_id: ""
                  }))
                }
                className={
                  newPrestation.caregiver_type === "external"
                    ? "bg-blue-600 text-white hover:bg-blue-700"
                    : "bg-white text-blue-800 border border-blue-300"
                }
              >
                Autres
              </Button>
            </div>
          </div>

          {newPrestation.caregiver_type === "registered" && (
            <div className="space-y-1 md:col-span-2">
              <Label>1. Sélectionner le soignant</Label>
              <select
                className="w-full rounded-md border border-[#d4ebeb] bg-white px-3 py-2"
                value={newPrestation.soignant_id}
                onChange={(e) => {
                  setNewPrestation((prev) => ({
                    ...prev,
                    soignant_id: e.target.value
                  }));
                  setPlanningDays({});
                }}
                required
              >
                <option value="">Choisir un soignant</option>
                {users.map((soignant) => {
                  const soignantId = getEntityId(soignant);
                  return (
                    <option key={soignantId} value={soignantId}>
                      {getFullName(soignant)} — {getRoleLabel(soignant)}
                    </option>
                  );
                })}
              </select>
            </div>
          )}

          {newPrestation.caregiver_type === "external" && (
            <div className="space-y-3 md:col-span-2">
              {!externalCaregiversUnlocked ? (
                <div className="rounded-lg border border-blue-200 bg-blue-50 p-4">
                  <p className="mb-3 font-medium text-blue-900">
                    Accès aux soignants externes
                  </p>
                  {user.role !== "admin" ? (
                    <p className="text-sm text-red-600">
                      Seul un administrateur peut afficher les soignants externes.
                    </p>
                  ) : (
                    <div className="space-y-3">
                      <Label>Code administrateur</Label>
                      <Input
                        type="password"
                        value={externalCaregiversCode}
                        onChange={(e) => setExternalCaregiversCode(e.target.value)}
                        placeholder="Entrez le code administrateur"
                      />
                      <Button
                        type="button"
                        disabled={checkingExternalCode}
                        onClick={handleUnlockExternalCaregivers}
                        className="bg-blue-600 text-white hover:bg-blue-700"
                      >
                        {checkingExternalCode
                          ? "Vérification..."
                          : "Afficher les soignants externes"}
                      </Button>
                    </div>
                  )}
                </div>
              ) : (
                <div className="space-y-2">
                  <Label>1. Sélectionner le soignant</Label>
                  <select
                    className="w-full rounded-md border border-blue-200 bg-white px-3 py-2"
                    value={newPrestation.soignant_externe_id}
                    onChange={(e) => {
                      setNewPrestation((prev) => ({
                        ...prev,
                        soignant_externe_id: e.target.value
                      }));
                      setPlanningDays({});
                    }}
                    required
                  >
                    <option value="">Choisir un soignant externe</option>
                    {externalCaregivers.map((soignant) => (
                      <option key={soignant._id} value={soignant._id}>
                        {getFullName(soignant)}
                        {soignant.care_role ? ` — ${soignant.care_role}` : ""}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>
          )}

          <div className="space-y-1 md:col-span-2">
            <Label>2. Sélectionner le patient</Label>
            <select
              className="w-full rounded-md border border-[#d4ebeb] bg-white px-3 py-2"
              value={newPrestation.patient_id || ""}
              onChange={(e) => {
                setNewPrestation((prev) => ({
                  ...prev,
                  patient_id: e.target.value
                }));
                setPlanningDays({});
              }}
              required
            >
              <option value="">Choisir un patient</option>
              {patients.map((patient) => (
                <option key={patient._id} value={patient._id}>
                  {getPatientDisplayName(patient)}
                </option>
              ))}
            </select>
          </div>

          <div className="space-y-1 md:col-span-2">
            <Label className="text-base">3. Choisir le mois</Label>
            <Input
              type="month"
              value={planningMonth}
              onChange={(e) => {
                setPlanningMonth(e.target.value);
                setPlanningDays({});
              }}
              required
            />
          </div>

          <div className="space-y-3 md:col-span-2">
            <div>
              <Label className="text-base">4. Sélectionner les jours de prestation</Label>
              <p className="mt-1 text-sm text-gray-500">
                Cliquez sur tous les jours où ce soignant intervient chez ce patient.
              </p>
            </div>

            {(() => {
              const { daysInMonth, startOffset } = getPlanningMonthInfo();
              const calendarCells = [
                ...Array(startOffset).fill(null),
                ...Array.from({ length: daysInMonth }, (_, index) => index + 1)
              ];

              return (
                <div className="rounded-xl border border-[#d4ebeb] bg-white p-4">
                  <div className="mb-2 grid grid-cols-7 gap-2 text-center text-xs font-semibold uppercase text-[#4f7d80]">
                    {["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"].map((day) => (
                      <div key={day}>{day}</div>
                    ))}
                  </div>

                  <div className="grid grid-cols-7 gap-2">
                    {calendarCells.map((day, index) => {
                      if (!day) {
                        return <div key={`empty-${index}`} className="h-14" />;
                      }

                      const date = formatPlanningDate(day);
                      const isSelected = Object.prototype.hasOwnProperty.call(
                        planningDays,
                        date
                      );
                      const passages = planningDays[date] || [];

                      return (
                        <button
                          key={date}
                          type="button"
                          onClick={() => togglePlanningDate(date)}
                          className={`min-h-16 rounded-lg border p-2 text-center transition ${
                            isSelected
                              ? "border-[#6faeb2] bg-[#e6f3f3] text-[#315f63] shadow-sm"
                              : "border-gray-200 bg-white text-gray-700 hover:border-[#b8dede] hover:bg-[#f4fafa]"
                          }`}
                        >
                          <span className="block text-base font-bold">{day}</span>
                          {isSelected && (
                            <span className="mt-1 block text-[10px] font-semibold">
                              {passages.length > 0
                                ? passages.map((p) => p === "matin" ? "M" : p === "midi" ? "Mi" : "S").join(" · ")
                                : "À configurer"}
                            </span>
                          )}
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })()}

            <div className="rounded-lg bg-[#e6f3f3] px-4 py-3 text-sm text-[#315f63]">
              <strong>{Object.keys(planningDays).length}</strong> date(s) sélectionnée(s)
            </div>
          </div>

          {Object.keys(planningDays).sort().length > 0 && (
            <div className="space-y-3 md:col-span-2">
              <div>
                <h4 className="text-lg font-semibold text-[#315f63]">
                  5. Choisir Matin / Midi / Soir pour chaque date
                </h4>
                <p className="mt-1 text-sm text-gray-500">
                  Le soignant et le patient restent les mêmes. Seuls les jours et les créneaux changent.
                </p>
              </div>

              {Object.keys(planningDays)
                .sort()
                .map((date) => {
                  const passages = planningDays[date] || [];

                  return (
                    <div
                      key={date}
                      className="rounded-xl border border-[#b8dede] bg-white p-4"
                    >
                      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                        <div>
                          <p className="font-bold text-[#315f63]">
                            {new Date(`${date}T12:00:00`).toLocaleDateString("fr-BE", {
                              weekday: "long",
                              day: "2-digit",
                              month: "long"
                            })}
                          </p>
                        </div>

                        <div className="flex flex-wrap gap-2">
                          <Button
                            type="button"
                            onClick={() => selectAllPlanningPassages(date)}
                            className="h-8 bg-[#e6f3f3] px-3 text-xs text-[#315f63] hover:bg-[#d4ebeb]"
                          >
                            Matin + Midi + Soir
                          </Button>
                          {Object.keys(planningDays).length > 1 && passages.length > 0 && (
                            <Button
                              type="button"
                              onClick={() => applyPassagesToAllDates(date)}
                              className="h-8 bg-[#e6f3f3] px-3 text-xs text-[#315f63] hover:bg-[#d4ebeb]"
                            >
                              Appliquer à toutes les dates
                            </Button>
                          )}
                          <Button
                            type="button"
                            onClick={() => clearPlanningDay(date)}
                            className="h-8 bg-slate-200 px-3 text-xs text-slate-800 hover:bg-slate-300"
                          >
                            Retirer
                          </Button>
                        </div>
                      </div>

                      <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-3">
                        {[
                          { value: "matin", label: "Matin", icon: "🌅" },
                          { value: "midi", label: "Midi", icon: "☀️" },
                          { value: "soir", label: "Soir", icon: "🌙" }
                        ].map((passage) => {
                          const selected = passages.includes(passage.value);

                          return (
                            <label
                              key={`${date}-${passage.value}`}
                              className={`flex cursor-pointer items-center justify-center gap-2 rounded-lg border px-3 py-3 font-medium transition ${
                                selected
                                  ? "border-green-500 bg-green-100 text-green-800"
                                  : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50"
                              }`}
                            >
                              <input
                                type="checkbox"
                                checked={selected}
                                onChange={() => togglePlanningPassage(date, passage.value)}
                                className="h-4 w-4 accent-green-600"
                              />
                              <span>{passage.icon}</span>
                              <span>{passage.label}</span>
                            </label>
                          );
                        })}
                      </div>

                      {passages.length === 0 && (
                        <p className="mt-2 text-xs font-medium text-red-600">
                          Sélectionnez au moins un créneau pour cette date.
                        </p>
                      )}
                    </div>
                  );
                })}
            </div>
          )}

          <div className="space-y-1 md:col-span-2">
            <Label>Note facultative</Label>
            <Input
              placeholder="Informations communes à ces prestations"
              value={newPrestation.notes}
              onChange={(e) =>
                setNewPrestation({
                  ...newPrestation,
                  notes: e.target.value
                })
              }
            />
          </div>

          <div className="flex flex-wrap gap-2 md:col-span-2">
            <Button
              type="submit"
              className="bg-[#6faeb2] hover:bg-[#5b979b] text-white"
            >
              Enregistrer les prestations
            </Button>

            <Button
              type="button"
              onClick={() => {
                setCreatingPrestation(false);
                setNewPrestation(getEmptyPrestation());
                setPlanningDays({});
              }}
              className="bg-slate-200 text-slate-800 hover:bg-slate-300"
            >
              Annuler
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  )}

  <div className="space-y-3">
    {prestations.length === 0 ? (
      <Card className="border-[#d4ebeb]">
        <CardContent className="p-6 text-center text-[#4f7d80]">
          Aucune prestation à domicile enregistrée.
        </CardContent>
      </Card>
    ) : (
      prestations.map((prestation) => {
        const soignantInterne =
          prestation.soignant ||
          users.find(
            (userItem) =>
              userItem._id ===
              (
                prestation.soignant_id?._id ||
                prestation.soignant_id
              )
          );

        const soignantExterne =
          prestation.soignant_externe ||
          externalCaregivers.find(
            (externalItem) =>
              externalItem._id ===
              (
                prestation.soignant_externe_id?._id ||
                prestation.soignant_externe_id
              )
          );

        const soignant =
          soignantInterne || soignantExterne;

        const patient =
          prestation.patient ||
          patients.find(
            (patientItem) =>
              patientItem._id ===
              (
                prestation.patient_id?._id ||
                prestation.patient_id
              )
          );

        const isExternalCaregiver =
          Boolean(
            prestation.soignant_externe_id ||
            prestation.soignant_externe
          );
        return (
          <Card
            key={prestation._id}
            className="border-[#d4ebeb] bg-white"
          >
            <CardContent className="p-5">
              <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                <div className="grid grid-cols-1 gap-3 text-sm sm:grid-cols-2 xl:grid-cols-5">
                  <div>
                    <p className="text-gray-500">Date</p>
                    <p className="font-semibold">
                      {prestation.date
                        ? new Date(
                            prestation.date
                          ).toLocaleDateString("fr-BE")
                        : "-"}
                    </p>
                  </div>

                  <div>
                    <p className="text-gray-500">Soignant</p>
                    <p className="font-semibold">
                      {soignant
                        ? getFullName(soignant)
                        : "Soignant inconnu"}
                      {isExternalCaregiver && (
                        <span className="text-xs font-medium text-blue-600">
                          Autre soignant
                        </span>
                      )}
                    </p>
                  </div>

                  <div>
                    <p className="text-gray-500">Patient</p>
                    <p className="font-semibold">
                      {patient
                        ? `${
                            patient.prenom ||
                            patient.first_name ||
                            ""
                          } ${
                            patient.nom ||
                            patient.last_name ||
                            ""
                          }`
                        : "Patient inconnu"}
                    </p>
                  </div>
                  <div>
                    <p className="text-gray-500">Passage(s)</p>
                    <div className="mt-1 flex flex-wrap gap-1">
                      {Array.isArray(prestation.passages) &&
                      prestation.passages.length > 0 ? (
                        prestation.passages.map((passage) => (
                          <span
                            key={passage}
                            className="rounded-full bg-green-100 px-2 py-1 text-xs font-semibold text-green-700"
                          >
                            {passage === "matin" && "🌅 Matin"}
                            {passage === "midi" && "☀️ Midi"}
                            {passage === "soir" && "🌙 Soir"}
                          </span>
                        ))
                      ) : (
                        <span className="text-sm text-gray-500">
                          Non précisé
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {canManagePrestations && (
                  <div className="flex gap-2">
                    <Button
                      type="button"
                      onClick={() => startEditPrestation(prestation)}
                      className="
                        bg-[#6faeb2]
                        hover:bg-[#4f8f94]
                        text-white
                        transition-colors
                        duration-200
                      "
                    >
                      Modifier
                    </Button>

                    <Button
                      type="button"
                      onClick={() => handleDeletePrestation(prestation._id)}
                      className="
                        bg-red-600
                        hover:bg-red-700
                        text-white
                        transition-colors
                        duration-200
                      "
                    >
                      Supprimer
                    </Button>
                  </div>
                )}
              </div>

              {prestation.notes && (
                <p className="mt-4 border-t pt-3 text-sm text-gray-600">
                  <strong>Note :</strong>{" "}
                  {prestation.notes}
                </p>
              )}
            </CardContent>
          </Card>
        );
      })
    )}
  </div>
</section>
{/* )} */}

{editingPrestation && (
  <Card className="border-blue-200 bg-blue-50">
    <CardContent className="p-5">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="font-semibold text-blue-800">
          Modifier la prestation
        </h3>

        <Button
          type="button"
          onClick={() => {
            setEditingPrestation(null);
            setNewPrestation(getEmptyPrestation());
          }}
          className="bg-slate-200 text-slate-800"
        >
          Annuler
        </Button>
      </div>

      <form
        onSubmit={handleUpdatePrestation}
        className="grid grid-cols-1 gap-4 md:grid-cols-2"
      >
        <div className="space-y-1">
          <Label>Date</Label>

          <Input
            type="date"
            value={newPrestation.date}
            onChange={(e) =>
              setNewPrestation({
                ...newPrestation,
                date: e.target.value
              })
            }
            required
          />
        </div>

        <div className="space-y-1 md:col-span-2">
  <Label>Type de soignant</Label>

  <div className="grid grid-cols-2 gap-3">
    <Button
      type="button"
      onClick={() =>
        setNewPrestation((prev) => ({
          ...prev,
          caregiver_type: "registered",
          soignant_externe_id: ""
        }))
      }
      className={
        newPrestation.caregiver_type === "registered"
          ? "bg-[#6faeb2] text-white hover:bg-[#5b979b]"
          : "bg-white text-[#3d6d71] border border-[#b8dede] hover:bg-[#f4fafa]"
      }
    >
      Soignants enregistrés
    </Button>

    <Button
      type="button"
      onClick={() => {
        setNewPrestation((prev) => ({
          ...prev,
          caregiver_type: "external",
          soignant_id: ""
        }));

        if (!externalCaregiversUnlocked) {
          setExternalCaregivers([]);
        }
      }}
            className={
        newPrestation.caregiver_type === "external"
          ? "bg-blue-600 text-white hover:bg-blue-700"
          : "bg-white text-blue-800 border border-blue-300 hover:bg-blue-50"
      }
    >
      Autres
    </Button>
  </div>
</div>

{newPrestation.caregiver_type === "registered" && (
  <div className="space-y-1 md:col-span-2">
    <Label>Soignant</Label>

    <select
      className="w-full rounded-md border border-[#d4ebeb] bg-white px-3 py-2"
      value={newPrestation.soignant_id}
      onChange={(e) =>
        setNewPrestation((prev) => ({
          ...prev,
          soignant_id: e.target.value
        }))
      }
      required
    >
      <option value="">
        Choisir un soignant
      </option>

      {users.length === 0 && (
        <option value="" disabled>
          Aucun infirmier ou aide-soignant trouvé
        </option>
      )}

      {users.map((soignant) => (
        <option
          key={soignant._id}
          value={soignant._id}
        >
          {getFullName(soignant)}
          {" — "}
          {getRoleLabel(soignant)}
        </option>
      ))}
    </select>
  </div>
)}

{newPrestation.caregiver_type === "external" && (
  <div className="space-y-3 md:col-span-2">
    {!externalCaregiversUnlocked ? (
      <div className="rounded-lg border border-blue-200 bg-blue-50 p-4">
        <p className="mb-3 font-medium text-blue-900">
          Accès réservé aux administrateurs
        </p>

        {user.role !== "admin" ? (
          <p className="text-sm text-red-600">
            Seul un administrateur peut afficher les soignants externes.
          </p>
        ) : (
          <form
            onSubmit={handleUnlockExternalCaregivers}
            className="space-y-3"
          >
            <Label>Code administrateur</Label>

            <Input
              type="password"
              value={externalCaregiversCode}
              onChange={(e) =>
                setExternalCaregiversCode(e.target.value)
              }
              placeholder="Entrez le code"
            />

            <Button
              type="submit"
              disabled={checkingExternalCode}
              className="bg-blue-600 text-white hover:bg-blue-700"
            >
              {checkingExternalCode
                ? "Vérification..."
                : "Afficher les soignants externes"}
            </Button>
          </form>
        )}
      </div>
    ) : (
      <div className="space-y-1">
        <div className="flex items-center justify-between">
          <Label>Autre soignant</Label>

          <Button
            type="button"
            onClick={() => {
              setExternalCaregiversUnlocked(false);
              setExternalCaregivers([]);
              setExternalCaregiversCode("");
              setNewPrestation((prev) => ({
                ...prev,
                soignant_externe_id: ""
              }));
            }}
            className="bg-slate-200 text-slate-800 hover:bg-slate-300"
          >
            Verrouiller
          </Button>
        </div>

        <select
          className="w-full rounded-md border border-blue-200 bg-white px-3 py-2"
          value={newPrestation.soignant_externe_id}
          onChange={(e) =>
            setNewPrestation((prev) => ({
              ...prev,
              soignant_externe_id: e.target.value
            }))
          }
          required
        >
          <option value="">
            Choisir un soignant externe
          </option>

          {externalCaregivers.map((soignant) => (
            <option
              key={soignant._id}
              value={soignant._id}
            >
              {getFullName(soignant)}
              {soignant.care_role
                ? ` — ${soignant.care_role}`
                : ""}
            </option>
          ))}
        </select>
      </div>
    )}
  </div>
)}

                <div className="space-y-1 md:col-span-2">
                  <Label>Patient</Label>

                  <select
                    className="w-full rounded-md border border-[#d4ebeb] bg-white px-3 py-2"
                    value={newPrestation.patient_id}
                    onChange={(e) =>
                      setNewPrestation((prev) => ({
                        ...prev,
                        patient_id: e.target.value
                      }))
                    }
                    required
                  >
                    <option value="">
                      Choisir un patient
                    </option>

                    {patients.length === 0 && (
                      <option value="" disabled>
                        Aucun patient actif trouvé
                      </option>
                    )}

                    {patients.map((patient) => (
                      <option
                        key={patient._id}
                        value={patient._id}
                      >
                        {patient.prenom || patient.first_name || ""}{" "}
                        {patient.nom || patient.last_name || ""}
                      </option>
                    ))}
                  </select>
                </div>

        <div className="space-y-1">
          <Label>Note</Label>

          <Input
            value={newPrestation.notes}
            onChange={(e) =>
              setNewPrestation({
                ...newPrestation,
                notes: e.target.value
              })
            }
          />
        </div>

        <Button
          type="submit"
          className="bg-blue-600 hover:bg-blue-700 text-white md:col-span-2"
        >
          Enregistrer les modifications
        </Button>
      </form>
    </CardContent>
  </Card>
)}
  </>
)}
</div>   
</div>
    </Layout>
  );
}
